import React from 'react';
import { useDialogKeyboard } from '../../../hooks/useDialogKeyboard';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  ModalClose,
  ModalDialog,
  Typography,
} from '@mui/joy';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

const DeleteFunctionModal = ({ open, onClose, onConfirm, functionName }) => {
  useDialogKeyboard(open, { onEnter: onConfirm, onEscape: onClose });

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog variant="outlined" role="alertdialog">
        <ModalClose />
        <DialogTitle>
          <WarningRoundedIcon sx={{ color: 'danger.500', mr: 1 }} />
          Delete Function
        </DialogTitle>
        <DialogContent>
          <Typography level="body-md">
            Are you sure you want to delete{' '}
            <Typography component="span" fontWeight="bold">
              {functionName}
            </Typography>
            ? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="solid" color="danger" onClick={onConfirm}>
            Delete
          </Button>
          <Button variant="plain" color="neutral" onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default DeleteFunctionModal;
